import React from "react";
import {
  Container,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import SectionHeading from "./SectionHeading";
import { colors, fonts } from "../theme";

const rows = [
  {
    dept: "CSE",
    bottleneck: "General languages; little exposure to modern distributed architectures.",
    solution: "Enterprise Node.js Backend & API Orchestration Tracks.",
    outcome: "Graduates ready to excel in advanced corporate technical evaluations.",
  },
  {
    dept: "IT",
    bottleneck: "Heavy database theory; limited live cloud infrastructure exposure.",
    solution: "Cloud Foundations & Live Serverless Ecosystem Implementations.",
    outcome: "Graduates capable of deploying software on modern cloud networks.",
  },
  {
    dept: "AI & DS",
    bottleneck: "Strong maths; limited experience deploying models in production.",
    solution: "MLOps Integration Pipelines & Production Data Flow Frameworks.",
    outcome: "Engineers who integrate intelligent models into enterprise apps.",
  },
  {
    dept: "ECE",
    bottleneck: "Isolated hardware concepts; minimal integration with cloud networks.",
    solution: "IoT Architecture Integration & Edge Computing Frameworks.",
    outcome: "Interdisciplinary graduates designing connected hardware ecosystems.",
  },
  {
    dept: "EEE",
    bottleneck: "Traditional power focus; lacks automated control & analytics skills.",
    solution: "Smart Grid Automation, Industrial IoT & System Telemetry Tracks.",
    outcome: "Graduates ready for smart-city and automated energy systems.",
  },
  {
    dept: "Mechanical",
    bottleneck: "Classic CAD/CAM; missing links with smart software systems.",
    solution: "Industry 4.0 Integration & Digital Twin Prototyping.",
    outcome: "Engineers prepared for automated smart-manufacturing roles.",
  },
  {
    dept: "Civil",
    bottleneck: "Manual tracking; missing data analytics & cloud collaboration.",
    solution: "Cloud-Based Project Tracking & BIM Collaboration Ecosystems.",
    outcome: "Construction engineers ready for data-driven infrastructure projects.",
  },
  {
    dept: "BCA",
    bottleneck: "Short lifecycles; insufficient time for deep industry projects.",
    solution: "Rapid Application Prototyping & Agile Software Deployment Tracks.",
    outcome: "Graduates with practical, competitive job-ready portfolios.",
  },
  {
    dept: "B.Sc Comp Sci",
    bottleneck: "Strong theory; limited exposure to live hosting environments.",
    solution: "Frontend Engineering with Firebase & Managed Cloud Platforms.",
    outcome: "Graduates ready for immediate software development positions.",
  },
  {
    dept: "MBA",
    bottleneck: "Descriptive case models; missing hands-on dashboard skills.",
    solution: "Data-Driven Management Analytics & Interactive KPI Dashboards.",
    outcome: "Leaders equipped to make confident, data-backed decisions.",
  },
];

const headCellSx = {
  color: colors.white,
  fontFamily: fonts.heading,
  fontWeight: 700,
  fontSize: "0.9rem",
  borderBottom: "none",
  whiteSpace: "nowrap",
};

const bodyCellSx = {
  color: colors.textBody,
  fontSize: "0.88rem",
  lineHeight: 1.55,
  verticalAlign: "top",
  borderBottom: "1px solid #eef2f7",
};

const DepartmentMatrix = () => {
  return (
    <section id="departments-section" className="departments-section">
      <Box sx={{ py: { xs: 5, md: 7 } }}>
        <Container>
          <SectionHeading
            eyebrow="Department-Wise Academic Impact"
            title="Tailored to Every Department's Curriculum & Career Path"
            subtitle="We map each department's specific bottleneck to a targeted program and a measurable institutional outcome."
          />
          <Box
            className="table-scroll"
            sx={{ borderRadius: 3, border: "1px solid #e6edf7", overflowX: "auto" }}
          >
            <TableContainer>
              <Table sx={{ minWidth: 760 }}>
                <TableHead>
                  <TableRow sx={{ background: colors.navy }}>
                    <TableCell sx={{ ...headCellSx }}>Department</TableCell>
                    <TableCell sx={{ ...headCellSx }}>Current Bottleneck</TableCell>
                    <TableCell sx={{ ...headCellSx }}>Targeted Crescent Program</TableCell>
                    <TableCell sx={{ ...headCellSx }}>Strategic Outcome</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {rows.map((r, i) => (
                    <TableRow
                      key={r.dept}
                      sx={{
                        bgcolor: i % 2 ? "#f8fafd" : colors.white,
                        transition: "background-color .2s ease",
                        "&:hover": { bgcolor: "rgba(56,182,255,0.08)" },
                      }}
                    >
                      <TableCell sx={{ ...bodyCellSx, fontWeight: 700, color: colors.navy, whiteSpace: "nowrap" }}>
                        {r.dept}
                      </TableCell>
                      <TableCell sx={bodyCellSx}>{r.bottleneck}</TableCell>
                      <TableCell sx={{ ...bodyCellSx, color: colors.blueDark, fontWeight: 600 }}>
                        {r.solution}
                      </TableCell>
                      <TableCell sx={bodyCellSx}>{r.outcome}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Container>
      </Box>
    </section>
  );
};

export default DepartmentMatrix;
